export default __webpack_public_path__ + "static/media/gamstop.52fbc84c.svg";